import { type RootState } from '../rmsStore'

export default function getAlarmReducer (state: RootState): AlarmsState {
  return state.alarmsReducer
}
